// Points-to-cash arithmetic, shared so the PWA offers exactly what the
// server will accept.

export interface PointsTerms {
  pointValue: number;
  maxSharePercent: number;
}

/** Naira value of points, rounded to kobo. */
export const pointsValue = (points: number, pointValue: number) => Math.round(points * pointValue * 100) / 100;

/** Most points that may go towards an offer of this price. */
export const maxPointsForPrice = (price: number, { pointValue, maxSharePercent }: PointsTerms) =>
  pointValue > 0 ? Math.floor((price * maxSharePercent) / 100 / pointValue + 1e-9) : 0;
